import { __decorate } from "tslib";
import $ from 'jquery';
import { getCurrentBreakpoint } from '../utils/breakpoint';
import { Breakpoint } from '../types/breakpoint';
import { throttle } from 'helpful-decorators';
import GaTracking from '../core/components/ga-tracking';
const DROPDOWN_SELECTOR = '.js__custom-dropdown';
const DROPDOWN_BUTTON_SELECTOR = '.js__custom-dropdown-button';
const MENU_SELECTOR = '.js__custom-dropdown-menu';
const WRAPPER_SELECTOR = '.js__custom-dropdown-wrapper';
const HIDEABLE_COLUMNS_WRAPPER_SELECTOR = '.js__custom-dropdown-hideable-columns-wrapper';
const CLOSE_BUTTON_SELECTOR = '.js__custom-dropdown-close';
const INPUT_SELECTOR = '.js__custom-dropdown-input';
const DROPDOWN_COLUMN_SELECTOR = '.js__custom-dropdown-column';
const STATIC_FIRST_COLUMN_SELECTOR = '.js__static-first-column';
export default class DropdownSelect {
    static $dropdownSelect = $(DROPDOWN_BUTTON_SELECTOR);
    static $menu = $(MENU_SELECTOR);
    static $closeButton = $(CLOSE_BUTTON_SELECTOR);
    static $relatedDropdownWrapper = '';
    static $relatedDropdownNamePrefix = '';
    static selectedValues = {};
    static allValues = [];
    static lastOpenedDropdownValue = '';
    static lastEventPushed = '';
    static selectedColumnIndexes = [];
    static visibleColumns = 3;
    static init($root = $('body'), isLoadedWithoutQueryParams = false) {
        this.$dropdownSelect = $root.find(DROPDOWN_BUTTON_SELECTOR);
        this.$menu = $root.find(MENU_SELECTOR);
        this.$closeButton = $root.find(CLOSE_BUTTON_SELECTOR);
        if (!this.$dropdownSelect.length || !this.$menu.length) {
            return;
        }
        this.$relatedDropdownWrapper = $(WRAPPER_SELECTOR).data('related-dropdown');
        this.$relatedDropdownNamePrefix = $(WRAPPER_SELECTOR).data('related-dropdown-name-prefix');
        this.allValues = $(WRAPPER_SELECTOR).data('all-values').split(',');
        this.visibleColumns = $(WRAPPER_SELECTOR).data('visible-columns');
        if (location.search && !isLoadedWithoutQueryParams) {
            this.selectedValues = Object.fromEntries(new URLSearchParams(location.search));
        }
        else {
            this.selectedValues = $(WRAPPER_SELECTOR).data('default-values');
            this.setUrlBySelectedValues();
        }
        this.$dropdownSelect.on('click', e => {
            this.openDropdown($(e.currentTarget));
            const $input = $(e.currentTarget).parent().find('input:checked');
            this.lastOpenedDropdownValue = $input.val() || '';
        });
        this.$dropdownSelect.on('keydown', e => {
            const $focused = $(':focus');
            const $currentDropdown = $(e.currentTarget);
            const $menu = $currentDropdown.closest(DROPDOWN_SELECTOR).find(MENU_SELECTOR);
            if (e.key === 'Enter' || e.key === ' ') {
                if ($focused.hasClass('js__custom-dropdown-button')) {
                    this.openDropdown($currentDropdown);
                    const $input = $currentDropdown.parent().find('input:checked');
                    this.lastOpenedDropdownValue = $input.val() || '';
                    $menu.find(':checked').trigger('focus');
                }
            }
        });
        $(INPUT_SELECTOR).on('keydown', e => {
            const $currentInput = $(e.currentTarget);
            const $currentDropdown = $(e.currentTarget).closest(DROPDOWN_SELECTOR);
            const $focusedOption = $currentDropdown.find(':focus');
            if (e.key === 'Enter' || e.key === ' ') {
                if ($focusedOption.length) {
                    setTimeout(() => {
                        $(`${DROPDOWN_COLUMN_SELECTOR}[data-option="${$currentInput.val()}"]`)
                            .find(DROPDOWN_BUTTON_SELECTOR)
                            .first()
                            .trigger('focus');
                    });
                }
                $(e.currentTarget).trigger('click');
            }
            else if (e.key === 'Escape') {
                if ($focusedOption.length) {
                    $currentDropdown.find(DROPDOWN_BUTTON_SELECTOR).trigger('focus');
                }
                this.closeDropdowns();
            }
            else if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
                e.preventDefault();
                const $focused = $currentDropdown.find(':focus');
                const $listItems = $currentDropdown.find(`${INPUT_SELECTOR}:not(:disabled)`);
                let index = $listItems.index($focused);
                if (e.key === 'ArrowDown') {
                    index = (index + 1) % $listItems.length;
                }
                if (e.key === 'ArrowUp') {
                    index = (index - 1 + $listItems.length) % $listItems.length;
                }
                $listItems.eq(index).focus();
            }
        });
        $(INPUT_SELECTOR).on('click', e => {
            this.closeDropdowns();
        });
        $(INPUT_SELECTOR).on('change', e => {
            const $changedInput = $(e.currentTarget);
            const changedInputName = $changedInput.attr('name') || '';
            const wrapper = changedInputName.includes(this.$relatedDropdownNamePrefix)
                ? this.$relatedDropdownWrapper
                : WRAPPER_SELECTOR;
            const value = $changedInput.val() || '';
            const $closestColumn = $changedInput.closest(DROPDOWN_COLUMN_SELECTOR);
            const $closestColumnDevice = $closestColumn.data('option');
            if ($closestColumnDevice !== value) {
                const $input = $(`${DROPDOWN_COLUMN_SELECTOR}[data-option="${$closestColumnDevice}"]`).find(`${INPUT_SELECTOR}[value="${$closestColumnDevice}"]`);
                $input.prop('checked', true);
                $(`${DROPDOWN_COLUMN_SELECTOR}[data-device="${value}"]`)
                    .find(`${INPUT_SELECTOR}[value="${value}"]`)
                    .prop('checked', true);
                const valueName = $input.attr('name')?.replace(this.$relatedDropdownNamePrefix, '') || '';
                // @ts-ignore
                this.selectedValues[`${valueName.replace(/[0-9]/g, '')}${$closestColumn.index() + 1}`] = value;
            }
            else {
                $(`${wrapper}`)
                    .find(`${DROPDOWN_BUTTON_SELECTOR}:visible`)
                    .find(`${INPUT_SELECTOR}:checked`)
                    .each((index, element) => {
                    const $element = $(element);
                    const $column = $element.closest(DROPDOWN_COLUMN_SELECTOR);
                    const $columns = $(`${HIDEABLE_COLUMNS_WRAPPER_SELECTOR}, ${WRAPPER_SELECTOR}`).children();
                    const deviceIndex = $columns.index($column) + 1;
                    const valueName = $element.attr('name')?.replace(this.$relatedDropdownNamePrefix, '') || '';
                    // @ts-ignore
                    this.selectedValues[`${valueName.replace(/[0-9]/g, '')}${deviceIndex}`] = $element.val();
                });
            }
            if (this.lastOpenedDropdownValue &&
                $changedInput.val() !== this.lastOpenedDropdownValue &&
                String($changedInput.val()) !== this.lastEventPushed) {
                this.lastEventPushed = String($changedInput.val());
                this.pushSelectedValueDataLayerEvent(String($changedInput.val()));
            }
            const duplicateKey = this.getKeyByValue(this.selectedValues, this.findDuplicates(Object.values(this.selectedValues))[0]);
            if (duplicateKey) {
                // @ts-ignore
                this.selectedValues[duplicateKey] = this.lastOpenedDropdownValue ? this.lastOpenedDropdownValue : null;
                $(`${INPUT_SELECTOR}[name="${duplicateKey}"]:checked, ${INPUT_SELECTOR}[name="${this.$relatedDropdownNamePrefix}${duplicateKey}"]:checked`).each((index, element) => {
                    $(element).last().prop('checked', false);
                });
            }
            this.setUrlBySelectedValues();
            this.reorderColumns();
            this.setSelectedValueInLabel($(e.currentTarget));
            this.disableUnavailableItems();
            this.setSelectedValues();
        });
        this.$closeButton.on('click', () => {
            this.closeDropdowns();
        });
        $(window).on('resize', () => {
            this.actionsOnResize();
        });
        $('body').on('click', `*:not(${DROPDOWN_SELECTOR})`, e => {
            if (!$(e.target).closest(DROPDOWN_SELECTOR).length) {
                this.closeDropdowns();
            }
        });
        this.reorderColumns();
        this.setSelectedValues();
        this.disableUnavailableItems();
    }
    static pushSelectedValueDataLayerEvent(value) {
        const dataLayer = this.$dropdownSelect.data('change-value-ga-event');
        if (dataLayer) {
            GaTracking.pushDataLayer({
                ...dataLayer,
                eventLabel: value,
            });
        }
    }
    static pushDropdownClickDataLayerEvent($element) {
        const $input = $element.parent().find('.js__custom-dropdown-input:checked');
        const dataLayer = this.$dropdownSelect.data('click-dropdown-ga-event');
        const orderNumber = Object.values(this.selectedValues).indexOf(String($input.val())) + 1;
        if (dataLayer) {
            GaTracking.pushDataLayer({
                ...dataLayer,
                eventLabel: `${orderNumber} - ${$input.val()}`,
            });
        }
    }
    static openDropdown($dropdown) {
        this.closeDropdowns();
        $dropdown.addClass('active');
        $dropdown.parent().find(MENU_SELECTOR).addClass('active');
        this.pushDropdownClickDataLayerEvent($dropdown);
    }
    static closeDropdowns() {
        this.$menu.each((index, element) => {
            $(element).removeClass('active');
            $(element).parent().find(DROPDOWN_BUTTON_SELECTOR).removeClass('active');
        });
    }
    static setUrlBySelectedValues() {
        const hash = window.location.hash;
        const newUrl = `${window.location.protocol}//${window.location.host}${window.location.pathname}?${new URLSearchParams({
            ...this.getAllQueryParameters(),
            ...this.selectedValues,
        }).toString()}${hash}`;
        window.history.replaceState({ path: newUrl }, '', newUrl);
    }
    static getAllQueryParameters() {
        const urlSearchParams = new URLSearchParams(window.location.search);
        return Object.fromEntries(urlSearchParams.entries());
    }
    static reorderColumns() {
        $(WRAPPER_SELECTOR).each((index, element) => {
            this.reorderColumnsInner(index, element, true);
        });
        $(HIDEABLE_COLUMNS_WRAPPER_SELECTOR).each((index, element) => {
            this.reorderColumnsInner(index, element);
        });
    }
    static reorderColumnsInner(index, element, checkStaticFirstColumn = false) {
        const columns = $(element).children();
        const selectedValues = Object.values(this.selectedValues);
        const currentBreakpoint = getCurrentBreakpoint();
        $(columns).removeClass('order-0 order-1 order-2 order-3 order-4 hidden-column d-none');
        if ($(element).find(`[data-option="${selectedValues[1]}"]`).length) {
            this.selectedColumnIndexes = [];
            const $firstColum = $(STATIC_FIRST_COLUMN_SELECTOR);
            if ($firstColum.length && checkStaticFirstColumn) {
                this.selectedColumnIndexes.push($(STATIC_FIRST_COLUMN_SELECTOR).index());
            }
            selectedValues.forEach((selectedValue, index) => {
                const $staticFirstColumn = $(element).find(STATIC_FIRST_COLUMN_SELECTOR);
                const $column = $staticFirstColumn.length && index === 0
                    ? $staticFirstColumn
                    : $(element).find(`[data-option="${selectedValue}"]`);
                if ($column.length) {
                    const columnIndex = $(columns).index($column);
                    this.selectedColumnIndexes.push(columnIndex);
                    $column.addClass(`order-${index}`);
                }
            });
        }
        else {
            this.selectedColumnIndexes.forEach((columnIndex, index) => {
                $(columns[columnIndex]).addClass(`order-${index}`);
            });
        }
        this.selectedColumnIndexes = [...new Set(this.selectedColumnIndexes)];
        $(columns).each((index, element) => {
            const $element = $(element);
            if (this.visibleColumns == 4) {
                if (!$element.hasClass('order-0') &&
                    !$element.hasClass('order-1') &&
                    !$element.hasClass('order-2') &&
                    !$element.hasClass('order-3')) {
                    $(element).addClass('order-4');
                }
            }
            else {
                if (!$element.hasClass('order-0') && !$element.hasClass('order-1') && !$element.hasClass('order-2')) {
                    $(element).addClass('order-3');
                }
            }
        });
        $(columns).each((index, element) => {
            if (currentBreakpoint < Breakpoint.lg) {
                if (this.visibleColumns == 4) {
                    if ($(element).hasClass('order-2') || $(element).hasClass('order-3') || $(element).hasClass('order-4')) {
                        $(element).addClass('hidden-column');
                    }
                }
                else {
                    if ($(element).hasClass('order-2') || $(element).hasClass('order-3')) {
                        $(element).addClass('hidden-column');
                    }
                }
            }
            else if ($(element)
                .attr('class')
                ?.includes(this.visibleColumns == 4 ? 'order-4' : 'order-3')) {
                $(element).addClass('hidden-column');
            }
            else {
                $(element).removeClass('hidden-column');
            }
        });
        if (this.visibleColumns == 4) {
            $(element).prepend($(element).find('.order-3'));
        }
        $(element).prepend($(element).find('.order-2'));
        $(element).prepend($(element).find('.order-1'));
        $(element).prepend($(element).find('.order-0'));
    }
    static actionsOnResize() {
        this.reorderColumns();
        this.disableUnavailableItems();
    }
    static getKeyByValue(object, value) {
        return Object.keys(object)
            .reverse()
            .find(key => object[key] === value);
    }
    static findDuplicates(array) {
        return array.filter((item, index) => array.indexOf(item) !== index);
    }
    static setSelectedValueInLabel($element) {
        const $wrapper = $element.closest(DROPDOWN_SELECTOR);
        const labelValue = $wrapper
            .find(`${INPUT_SELECTOR}:checked`)
            .next()
            .find('.js__custom-dropdown-option-label')
            .html();
        $wrapper.find(DROPDOWN_BUTTON_SELECTOR).html(labelValue);
    }
    static setSelectedValues() {
        const selectedValues = Object.values(this.selectedValues);
        const selectedKeys = Object.keys(this.selectedValues);
        selectedKeys.forEach((key, index) => {
            $($(INPUT_SELECTOR).closest(WRAPPER_SELECTOR).children().get(index))
                .find(`${INPUT_SELECTOR}[value="${selectedValues[index]}"]`)
                .each((index, element) => {
                const $element = $(element);
                if ($element.is(':not(:checked)')) {
                    $element.prop('checked', true);
                }
                this.setSelectedValueInLabel($element);
            });
        });
    }
    static disableUnavailableItems() {
        const selectedValues = Object.values(this.selectedValues);
        const currentBreakpoint = getCurrentBreakpoint();
        const visibleColumns = currentBreakpoint < Breakpoint.lg ? [0, 1] : this.visibleColumns == 4 ? [0, 1, 2, 3] : [0, 1, 2];
        const isFirstColumnSelected = $(STATIC_FIRST_COLUMN_SELECTOR).length;
        $(INPUT_SELECTOR).prop('disabled', false);
        selectedValues.forEach((value, valueIndex) => {
            if (visibleColumns.includes(valueIndex)) {
                $(DROPDOWN_SELECTOR)
                    .find(`${MENU_SELECTOR}:visible`)
                    .each((index, element) => {
                    const columnIndex = isFirstColumnSelected ? index + 1 : index;
                    if (visibleColumns.includes(columnIndex) && valueIndex !== columnIndex) {
                        $(element).find(`${INPUT_SELECTOR}[value="${value}"]`).prop('disabled', true);
                    }
                });
                $(this.$relatedDropdownWrapper)
                    .find(`${MENU_SELECTOR}:visible`)
                    .each((index, element) => {
                    const columnIndex = isFirstColumnSelected ? index + 1 : index;
                    if (visibleColumns.includes(columnIndex) && valueIndex !== columnIndex) {
                        $(element).find(`${INPUT_SELECTOR}[value="${value}"]`).prop('disabled', true);
                    }
                });
            }
        });
    }
}
__decorate([
    throttle(100)
], DropdownSelect, "actionsOnResize", null);
